'use strict';

module.exports = function () {
    // returns true
    // comment
    // hello
    return true;
};



// WEBPACK FOOTER //
// ./src/index.js